export default "__VITE_ASSET__Cfw73$na__"